var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,20.5c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C20.5,16,16,20.5,10.5,20.5z  M10.5,2.5c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S14.9,2.5,10.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,9.7L8.5,6C8.1,5.8,7.6,5.9,7.3,6.3C7.2,6.4,7.2,6.6,7.2,6.8v7.3c0,0.5,0.4,0.8,0.8,0.8 c0.2,0,0.3,0,0.4-0.1l6.2-3.7c0.4-0.2,0.5-0.8,0.3-1.2C14.9,9.9,14.8,9.8,14.7,9.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.183fa1e8479455f3d5280c32c0073509.svg";
export { ForwardRef as ReactComponent };